(function () {
  const panel = document.getElementById("search-panel");
  const close = document.getElementById("search-panel-close");
  const toggle = document.getElementById("search-panel-toggle");
  const input = document.getElementById("search-panel-input");

  if (!panel || !close || !toggle) return;

  const handleClickOutside = (e) => {
    if (panel.contains(e.target)) return;
    closePanel();
  };

  const openPanel = () => {
    panel.removeAttribute("hidden");
    setTimeout(() => {
      document.addEventListener("click", handleClickOutside);
      panel.dataset.open = true;
      input && input.focus();
    }, 10);
  };

  const closePanel = () => {
    document.removeEventListener("click", handleClickOutside);
    panel.dataset.open = false;
    panel.addEventListener(
      "transitionend",
      (e) => {
        if (e.target !== panel) return;

        if (input) input.value = "";
        panel.hidden = true;
      },
      { once: true }
    );
  };

  toggle.addEventListener("click", () => openPanel());

  close.addEventListener("click", () => closePanel());
})();
